let uid = 0
let listeners = {}
let scrollbar
let scrollbars = []
let top = true
let offset = 0

const onScroll = (status) => {
	offset = status.offset.y
	if (offset>50) {
		if (top) {
			top = false
			document.body.classList.add('not-top')
		}
	} else {
		if (!top) {
			top = true
			document.body.classList.remove('not-top')
		}
	}
	Object.keys(listeners).forEach(key => listeners[key](status, scrollbar))
}

const registerScrollbar = sc => {
	if(!sc) return
	setTimeout(() => {
		scrollbars.push(sc)
		scrollbar = scrollbars[scrollbars.length-1].scrollbar
		scrollbar.addListener(onScroll)
	})
}
const unregisterScrollbar = sc => {
	scrollbars = scrollbars.filter(s => s!==sc)
	if(scrollbars.length>0) {
		scrollbar = scrollbars[scrollbars.length-1].scrollbar
		return
	}
	scrollbar = null
}

const addScrollListener = cb => {
	uid += 1
	listeners[uid] = cb
	return uid
}

const removeScrollListener = uid => delete listeners[uid]

const scrollTo = id => {if(scrollbar) scrollbar.scrollIntoView(document.getElementById(id))}
const scrollToElem = elem => {if(scrollbar) scrollbar.scrollIntoView(elem, {offsetTop: 76})}
//const scrollTo = id => {console.log('scroll to '+id, scrollbar);scrollbar.scrollTo(0, 1000);}
const scrollToTop = () => {if(scrollbar) scrollbar.scrollTo(0,0,300)}
const scrollSetPosition = pos => {if(scrollbar) scrollbar.setPosition(0, pos)}
const scrollToTopIfNeeded = () => {
	if(offset<400) return
	
	if(scrollbar) {
		scrollSetPosition(200)
		scrollbar.scrollTo(0,0,300)
	}
}
export {
	registerScrollbar, 
	unregisterScrollbar, 
	addScrollListener, 
	removeScrollListener, 
	scrollTo, 
	scrollToElem, 
	scrollToTop, 
	onScroll,
	scrollSetPosition,
	scrollToTopIfNeeded
}



// WEBPACK FOOTER //
// ./src/fm/lib/ScrollObserver.js